import OverViewIcon from "../Icons/OverViewIcon";
import { Outlet } from "react-router-dom";
import KMrecordIcon from "../Icons/KMRecordIcon";
import VehicleICategoryIcon from "../Icons/VehicleICategoryIcon";
import VehicelTypeIcon from "../Icons/VehicelTypeIcon";
import vehicleIcon from "../Icons/vehicleIcon";
//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

import { getKey } from "../helpers/sessionKey";
import WelcomeIcon from "../Icons/WelcomeIcon";

export const shouldShowWelcome = getKey("shouldShowWelcome");
export const navigation: any = [
  {
    name: "Dashboard",
    href: "",
    icon: "",
    children: [
      ...(shouldShowWelcome === "true" || shouldShowWelcome === null
        ? [
            {
              name: "Welcome",
              href: "/fleet",
              icon: WelcomeIcon,
              activeIcon: WelcomeIcon,
            },
            {
              name: "Overview",
              href: "/fleet/overview",
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]
        : [
            {
              name: "Overview",
              href: "/fleet",
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]),
    ],
  },
  {
    name: "Fleet",
    href: "",
    icon: "",
    children: [
      // {
      //   name: "Vehicle Category",
      //   href: "/fleet/vehicle-category",
      //   icon: VehicleICategoryIcon,
      //   activeIcon: VehicleICategoryIcon,
      // },
      // {
      //   name: "Vehicle Type",
      //   href: "/fleet/vehicle-type",
      //   icon: VehicelTypeIcon,
      //   activeIcon: VehicelTypeIcon,
      // },
      {
        name: "Vehicle",
        href: "/fleet/vehicle",
        icon: vehicleIcon,
        activeIcon: vehicleIcon,
      },
      {
        name: "KM Record",
        href: "/fleet/km-record",
        icon: KMrecordIcon,
        activeIcon: KMrecordIcon,
        children: [],
      },
    ],
  },
  {
    name: "Tracking",
    href: "",
    icon: "",
    children: [
      {
        name: "Map",
        href: "/fleet/map",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
    ],
  },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw` p-2 h-full`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
